// import React, { useEffect, useState } from "react";
// import {
//   subscribeEmployees,
//   setEmployeeStatus,
//   deleteEmployee,
// } from "../../lib/employeesApi";
// import {
//   subscribeCategories,
//   subscribeSubcategories,
// } from "../../lib/servicesApi";
// import EmployeeDetailsModal from "../../Employee/EmployeeDetailsModal";

// const decode = (s) => String(s || "");

// export default function EmployeesRequests() {
//   const [pending, setPending] = useState([]);
//   const [error, setError] = useState(null);
//   const [cats, setCats] = useState([]);
//   const [subcats, setSubcats] = useState([]);
//   const [showDetail, setShowDetail] = useState(null);

//   useEffect(
//     () => subscribeEmployees(setPending, setError, { status: "pending" }),
//     []
//   );
//   useEffect(() => subscribeCategories(setCats, () => {}), []);
//   useEffect(() => subscribeSubcategories(setSubcats, () => {}), []);

//   const subLabel = (e) =>
//     decode(
//       subcats.find(
//         (sc) => sc.key === e.subcategoryKey && sc.categoryKey === e.categoryKey
//       )?.label ||
//         e.subcategoryKey ||
//         "-"
//     );
//   const catLabel = (key) =>
//     decode(cats.find((c) => c.key === key)?.label || key || "Uncategorized");

//   return (
//     <div className="card shadow-sm">
//       <div className="card-body">
//         <h5 className="card-title">Request for Employment (Pending)</h5>
//         {error && <div className="alert alert-danger">{error.message}</div>}

//         {pending.length === 0 ? (
//           <p className="text-muted mb-0">No pending requests.</p>
//         ) : (
//           <div className="table-responsive">
//             <table className="table table-sm align-middle">
//               <thead>
//                 <tr>
//                   <th>Emp ID</th>
//                   <th>Name</th>
//                   <th>Mobile</th>
//                   <th>Aadhaar</th>
//                   <th>Category</th>
//                   <th>Subcategory</th>
//                   <th style={{ width: 220 }}>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {pending.map((e) => (
//                   <tr
//                     key={e.id}
//                     style={{ cursor: "pointer" }}
//                     onClick={() => setShowDetail(e)}
//                   >
//                     <td>{e.empId}</td>
//                     <td>{`${e.firstName || ""} ${e.lastName || ""}`}</td>
//                     <td>{e.mobile || "-"}</td>
//                     <td>{e.aadhaar || "-"}</td>
//                     <td>{catLabel(e.categoryKey)}</td>
//                     <td>{subLabel(e)}</td>
//                     <td>
//                       <div className="d-flex gap-2">
//                         <button
//                           className="btn btn-outline-success btn-sm"
//                           type="button"
//                           onClick={(ev) => {
//                             ev.stopPropagation();
//                             setEmployeeStatus(e.id, "approved");
//                           }}
//                         >
//                           Approve
//                         </button>
//                         <button
//                           className="btn btn-outline-danger btn-sm"
//                           type="button"
//                           onClick={(ev) => {
//                             ev.stopPropagation();
//                             setEmployeeStatus(e.id, "rejected");
//                           }}
//                         >
//                           Reject
//                         </button>
//                         <button
//                           className="btn btn-outline-secondary btn-sm"
//                           type="button"
//                           onClick={(ev) => {
//                             ev.stopPropagation();
//                             deleteEmployee(e.id);
//                           }}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         <EmployeeDetailsModal
//           show={!!showDetail}
//           onClose={() => setShowDetail(null)}
//           employee={showDetail}
//         />
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  subscribeEmployees,
  setEmployeeStatus,
  deleteEmployee,
} from "../../lib/employeesApi";
import EmployeeDetailsModal from "../../Employee/EmployeeDetailsModal";
import {
  subscribeCategories,
  subscribeSubcategories,
} from "../../lib/servicesApi";

const decode = (s) => String(s || "");

export default function EmployeesRequests() {
  const [pending, setPending] = useState([]);
  const [error, setError] = useState(null);
  const [cats, setCats] = useState([]);
  const [subcats, setSubcats] = useState([]);
  const [showDetail, setShowDetail] = useState(null);

  useEffect(
    () => subscribeEmployees(setPending, setError, { status: "pending" }),
    []
  );
  useEffect(() => subscribeCategories(setCats, () => {}), []);
  useEffect(() => subscribeSubcategories(setSubcats, () => {}), []);

  const catLabel = (key) =>
    decode(cats.find((c) => c.key === key)?.label || key || "Uncategorized");
  const subLabel = (e) =>
    decode(
      subcats.find(
        (sc) => sc.key === e.subcategoryKey && sc.categoryKey === e.categoryKey
      )?.label ||
        e.subcategoryKey ||
        "-"
    );

  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title">Request for Employment (Pending)</h5>
        {error && <div className="alert alert-danger">{error.message}</div>}

        {pending.length === 0 ? (
          <p className="text-muted mb-0">No pending requests.</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-sm align-middle">
              <thead>
                <tr>
                  <th>Emp ID</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Aadhaar</th>
                  <th>Category</th>
                  <th>Subcategory</th>
                  <th style={{ width: 220 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {pending.map((e) => (
                  <tr
                    key={e.id}
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowDetail(e)}
                  >
                    <td>{e.empId}</td>
                    <td>{`${e.firstName || ""} ${e.lastName || ""}`}</td>
                    <td>{e.mobile || "-"}</td>
                    <td>{e.aadhaar || "-"}</td>
                    <td>{catLabel(e.categoryKey)}</td>
                    <td>{subLabel(e)}</td>
                    <td>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-outline-success btn-sm"
                          type="button"
                          onClick={(ev) => {
                            ev.stopPropagation();
                            setEmployeeStatus(e.id, "approved");
                          }}
                        >
                          Approve
                        </button>
                        <button
                          className="btn btn-outline-danger btn-sm"
                          type="button"
                          onClick={(ev) => {
                            ev.stopPropagation();
                            setEmployeeStatus(e.id, "rejected");
                          }}
                        >
                          Reject
                        </button>
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          type="button"
                          onClick={(ev) => {
                            ev.stopPropagation();
                            deleteEmployee(e.id);
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* <EmployeeDetailsModal
          show={!!showDetail}
          onClose={() => setShowDetail(null)}
          employee={showDetail}
        /> */}

        <EmployeeDetailsModal
          style={{ zIndex: 9999 }}
          show={!!showDetail}
          onClose={() => setShowDetail(null)}
          employee={showDetail}
        />
      </div>
    </div>
  );
}
